import React, { useState } from 'react';
import Edit from "../components/Edit";
import { useAdmin } from '../auth/AdminContext';
import { updateContent } from '../services/api';

const Touge = ({ title, onTitleUpdate }) => {
  const [info, setInfo] = useState("");
  const [isEditingTitle, setIsEditingTitle] = useState(false);
  const [newTitle, setNewTitle] = useState(title);
  const { isAdmin, token } = useAdmin();

  const handleTitleSave = () => {
    updateContent('title_touge', newTitle, token)
      .then(() => {
        onTitleUpdate(newTitle);
        setIsEditingTitle(false);
      })
      .catch(() => {});
  };

  return (
    <div>
      {isAdmin && (
        <h1>
          {isEditingTitle ? (
            <input
              type="text"
              value={newTitle}
              onChange={(e) => setNewTitle(e.target.value)}
            />
          ) : (
            title
          )}
          {!isEditingTitle && (
            <button onClick={() => { setNewTitle(title); setIsEditingTitle(true); }}>Muokkaa otsikkoa</button>
          )}
          {isEditingTitle && (
            <>
              <button onClick={handleTitleSave}>Tallenna</button>
              <button onClick={() => setIsEditingTitle(false)}>Peruuta</button>
            </>
          )}
        </h1>
      )}
      <Edit
        title={`${title} - Info`}
        contentKey="touge_info"
        value={info}
        onChange={setInfo}
      />
    </div>
  );
};

export default Touge;